export default __webpack_public_path__ + "static/media/curved9.ec7010fa.jpg";